export default __webpack_public_path__ + "static/media/client-14.5d1da065.png";